<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-toolbar class="headline gradiente lighten-2 elevation-3">
          <v-toolbar-title>
            <v-flex xs12>
              <div class="white--text">
                {{
                  $t('extracurricular.add_students_modal.add_students_title')
                }}
              </div>
            </v-flex>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex pt-3 px-4>
          <v-text-field
            v-model="filters.search"
            @keyup.enter="
              filters.offset = 0
              getAllStudents(true)
            "
            @click:clear="
              filters.offset = 0
              getAllStudents(true)
            "
            :label="$t('extracurricular.add_students_modal.search_student')"
            append-icon="search"
            :disabled="working.wUpdate"
            :autofocus="!working.wUpdate"
            clearable
          >
            <template v-slot:prepend>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">help</v-icon>
                </template>
                {{ $t('extracurricular.add_students_modal.search_help') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex pt-3 px-4>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-select
                solo-inverted
                item-text="typeLevel"
                no-data-text="Agrega actividades extracurriculares en el apartado Niveles."
                :items="levels"
                return-object
                @change="filterGGsByLevel"
                v-model="selected.level"
                :label="$t('extracurricular.add_students_modal.level')"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                @change="$forceUpdate()"
                no-data-text="No hay grupos"
                return-object
                solo-inverted
                :items="ggs"
                :item-text="text"
                v-model="selected.gg"
                :label="$t('extracurricular.add_students_modal.groups')"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-card-text>
          <v-list subheader two-line>
            <v-subheader>
              {{ $t('extracurricular.add_students_modal.students') }}
            </v-subheader>
            <RecycleScroller
              :items="students"
              :item-size="80"
              key-field="id"
              :prerender="5"
              style="height: 50vh"
              id="contentStudentsExtraModal"
            >
              <template v-slot="{ item }">
                <v-list-tile avatar>
                  <v-list-tile-action>
                    <v-checkbox
                      color="primary"
                      :value="item.id"
                      :key="item.id"
                      v-model="selected.students"
                      :disabled="isIn(item)"
                    ></v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-avatar>
                    <v-avatar size="50">
                      <img
                        v-if="item.imageStorage && item.imageStorage.miniObjUrl"
                        :src="item.imageStorage.miniObjUrl"
                      />
                      <img
                        v-else
                        :src="require('@/assets/panel/home/SKLB-Alumnos.png')"
                      />
                    </v-avatar>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="item.firstName + ' ' + item.lastName"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="
                        item.level.typeLevel +
                        ', ' +
                        item.gg.grade +
                        '' +
                        item.gg.group
                      "
                    ></v-list-tile-sub-title>
                    <v-divider :inset="true"></v-divider>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </RecycleScroller>
            <v-progress-linear
              v-if="working.wUpdate"
              height="2"
              :indeterminate="true"
            ></v-progress-linear>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">
            {{ $t('generic.cancel') }}
          </v-btn>
          <v-btn
            :disabled="working.wUpdate"
            color="primary darken-1"
            flat
            @click="save"
          >
            {{ $t('generic.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."></loading>
    <success v-model="toast.success" text="Operación exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </div>
</template>

<script>
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import error from '../Dialogs/Error.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'
export default {
  components: {
    loading,
    success,
    error,
  },
  props: ['value'],
  watch: {
    value() {
      this.selected.students = []
      if (this.value) {
        this.students = []
        this.getLevels()
        this.getAllStudents()
        document
          .getElementById('contentStudentsExtraModal')
          .addEventListener('scroll', this.handleScroll)
      } else {
        document
          .getElementById('contentStudentsExtraModal')
          .removeEventListener('scroll', this.handleScroll)
      }
    },
  },
  data: () => ({
    filters: {
      search: '',
      offset: 0,
      size: 10,
    },
    working: {
      wUpdate: false,
    },
    selected: {
      level: {},
      gg: {},
      students: [],
    },
    students: [],
    levels: [],
    ggs: [],
    toast: {
      failed: false,
      success: false,
    },
    totalStudents: 0,
  }),
  methods: {
    text: (item) => item.grade + '' + item.group,
    filterGGsByLevel(val) {
      this.selected.gg = {}
      var v = this
      this.levels.filter((item) => {
        if (item.id == val.id) {
          v.ggs = item.ggs
          v.$forceUpdate()
        }
      })
    },
    handleScroll() {
      var event = document.getElementById('contentStudentsExtraModal')
      if (event.offsetHeight + event.scrollTop >= event.scrollHeight) {
        if (this.students.length < this.totalStudents) {
          this.filters.offset = this.students.length
          this.getAllStudents()
        }
      }
    },
    getAllStudents(flag = false) {
      this.working.wUpdate = true
      this.$store
        .dispatch('student/getStudentsByBranch', this.filters)
        .then((response) => {
          this.students = flag
            ? response.data.entity
            : this.students.concat(response.data.entity)
          this.totalStudents = response.data.filters.total
          this.working.wUpdate = false
        })
        .catch((error) => {
          console.log(error)
          this.working.wUpdate = false
        })
    },
    getLevels() {
      this.working.wUpdate = true
      this.$store
        .dispatch('tutor/getLevelsExtraTool')
        .then((response) => {
          this.levels = response.data.entity.extracurricular
          this.working.wUpdate = false
        })
        .catch((error) => {
          this.working.wUpdate = false
          console.log(error)
        })
    },
    close() {
      this.filters.search = ''
      this.filters.offset = 0
      this.$emit('input', false)
    },
    save() {
      if (this.selected.students.length > 0) {
        this.working.wUpdate = true
        var students = this.selected.students.map((item) => ({
          id: item,
          gg: {
            id: this.selected.gg.id,
          },
          level: {
            id: this.selected.level.id,
          },
        }))
        this.$store
          .dispatch('student/linkStudentsLevelExtra', students)
          .then((response) => {
            this.selected.students = []
            this.working.wUpdate = false
            this.toast.success = true
            this.$emit('success')
            this.close()
          })
          .catch((error) => {
            this.working.wUpdate = false
            this.toast.failed = true
            console.log(error)
          })
      }
    },
    isIn(item) {
      if (this.selected.level.id && this.selected.gg.id) {
        if (item.extras) {
          for (var extra of item.extras) {
            if (
              extra.level.id == this.selected.level.id &&
              extra.gg.id == this.selected.gg.id
            ) {
              return true
            }
          }
        }
        return false
      }
      return true
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.close()
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
}
</script>

<style scoped>
/deep/ .v-input .v-input__slot {
  border-radius: 33px !important;
}

/deep/ .v-menu__content {
  border-radius: 23px;
}
</style>
